import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { Input, Label, Container, Row, Button, ButtonToolbar, Alert, Col, Table, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledTooltip, Popover, PopoverHeader, PopoverBody } from 'reactstrap';

import api from '../../api/api.js';
import apiFunctions from "../../api/functions.js";
import { getPedidoViandaFromCodigoVerificacion, getDatosUsuarioLogueado, getLugaresEntregaData, getComedoresData } from "../../api/calls.js";

import ModalConfirmacionPedidoProducto from "./ModalConfirmacionPedidoProducto.js"
import ModalListaDeProductos from './ModalListaDeProductos.js';

import ParadigmaLabeledInput from "../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import ParadigmaAsyncSeeker from "../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaDatePicker from '../../components/ParadigmaDatePicker/ParadigmaDatePicker.js'

import { abbreviatedTipoPedido, getUrlProductosTipoPedido, getUrlMisPedidosTipoPedido, getIconoClassnameTipoPedido, getIconoColorTipoPedido, getReadableTipoPedido } from './enums.js';

import './FormPedidosProducto.scss'

class FormPedidosProducto extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dependencia_id: null, // Se llama Centro Costo en la UI
            persona_id: null,
            producto_id: null,
            comedor_id: null, // Se llama Planta en la UI
            producto: null,
            cantidad: 0,
            detalle_pedido: [],
            productosComedor: [],

            observacion: '',

            // Lugar de entrega, igual que en el formulario de viandas: se elige
            // uno de la lista y se guarda su id en lugarEntrega, salvo que se
            // elija "Otros", que es el unico caso en que se escribe a mano en
            // lugar_entrega_otros.
            comedoresSelect: [],
            lugaresEntregaSelect: [],
            lugarEntrega: null,
            lugar_entrega_otros: null,

            selected_fecha_entrega: null,

            isOpenModal: false,
            msjModal: '',

            isOpenModalStock: false,
            isOpenPopoverAP: false,

            errors: [],

            productos: [],

            // Datos del User Logeado
            user_nombre: null,
            user_apellido: null,
        };
    }

    static propTypes = {
        tipo_pedido: PropTypes.string.isRequired, // de tipo abbreviatedTipoPedido, ver enums.js en esta carpeta para saber cuales son los posibles valores
    }

    // Id de la opcion "Otros" del select de lugares de entrega. Es negativo
    // para que no pueda chocar con el id de un area real; al enviar no se manda
    // como area_id sino como null, y el lugar va en otros_lugar_de_entrega.
    // Mismo valor y mismo criterio que en FormViandas.
    OPCION_LUGAR_ENTREGA_OTROS_ID = -1;

    /**
     * Vacia el formulario. No toca isOpenModal ni msjModal: el modal de exito
     * no es un campo del formulario, lo cierra el usuario.
     */
    resetForm = () => {
        return new Promise((resolve, reject) => {
            this.setState({
                dependencia_id: null,
                persona_id: null,
                producto_id: null,
                comedor_id: null,
                producto: null,
                cantidad: 0,
                detalle_pedido: [],
                productosComedor: [],
                observacion: '',
                lugarEntrega: null,
                lugar_entrega_otros: null,
                selected_fecha_entrega: null,
                isOpenModalStock: false,
                isOpenPopoverAP: false,
                errors: [],
                productos: [],
                user_nombre: null,
                user_apellido: null,
            }, () => {
                // Resolve the promise after the state has been updated
                resolve('Form has been reset.');
            });
        });
    }

    cargarComedores = () => {
        return getComedoresData().then((comedoresData) => {
            return new Promise((resolve) => {
                this.setState({ comedoresSelect: comedoresData || [] }, resolve);
            });
        });
    }

    cargarLugaresDeEntrega = () => {
        return getLugaresEntregaData().then((lugaresEntregaData) => {
            const opcionOtros = { id: this.OPCION_LUGAR_ENTREGA_OTROS_ID, nombre: 'Otros' } // Misma forma que devuelve el select de areas
            const lugaresEntregaSelect = [opcionOtros, ...(lugaresEntregaData || [])]; // La opcion otros tiene que estar en primer lugar para mayor comodidad

            return new Promise((resolve) => {
                this.setState({ lugaresEntregaSelect: lugaresEntregaSelect }, resolve);
            });
        });
    }

    fetchDataPedidos = () => {
        const { pedidoViandaCodigoVerificacion } = this.props.match.params;
        const isPedidoInsumos = this.props.tipo_pedido === abbreviatedTipoPedido.insumos;

        // Las dos listas van antes que los datos del pedido: la regla de Galvan
        // busca "Posta Inflamables" dentro de lugaresEntregaSelect y mira el
        // nombre del comedor en comedoresSelect, asi que si se cargaran despues
        // el autocompletado del adjunto no encontraria ninguna de las dos.
        Promise.all([this.cargarComedores(), this.cargarLugaresDeEntrega()]).then(() => {
            if (isPedidoInsumos && pedidoViandaCodigoVerificacion) {
                this.capturarDatosFromPedidoVianda(pedidoViandaCodigoVerificacion);
            } else {
                this.capturarDatosUsuarioLogueado();
            }
        });

        this.traerProductos();
    }

    /**
     * Indica si el formulario esta completando un pedido de insumos para
     * adjuntarlo a un pedido de vianda.
     *
     * En ese caso la cabecera la define el pedido de vianda, no el usuario: los
     * campos se autocompletan y quedan deshabilitados para que los dos pedidos
     * lleguen al reparto con los mismos datos y lo unico que haya que elegir
     * sean los insumos.
     *
     * La condicion es la misma que decide el autocompletado en
     * fetchDataPedidos(), a proposito: si fuera solo el parametro de la url, una
     * categoria que no se puede adjuntar quedaria con los campos bloqueados y
     * sin autocompletar, o sea imposible de completar.
     */
    estaAdjuntandoAVianda = () => {
        const esPedidoInsumos = this.props.tipo_pedido === abbreviatedTipoPedido.insumos;
        return esPedidoInsumos && Boolean(this.props.match.params.pedidoViandaCodigoVerificacion);
    }

    /**
     * Cuando el comedor de Galvan esta elegido el lugar de entrega solo puede
     * tener un valor, "Posta Inflamables", asi que se autoselecciona y el input
     * queda deshabilitado. Misma regla que la planta Galvan en FormViandas.
     */
    isComedorGalvanSelected = (comedorId) => {
        const { comedoresSelect } = this.state;
        const comedor = comedoresSelect ? comedoresSelect.find(c => c.id === comedorId) : null;

        return Boolean(comedor && comedor.nombre && comedor.nombre.toLowerCase() === "galvan");
    }

    isLugarDeEntregaInputDisabled = () => {
        const { comedor_id } = this.state;
        return this.estaAdjuntandoAVianda() || this.isComedorGalvanSelected(comedor_id);
    }

    /**
     * El lugar de entrega que impone el comedor elegido, si impone alguno.
     *
     * Hoy el unico caso es Galvan, donde solo puede ser "Posta Inflamables".
     * Devuelve null cuando el comedor no fuerza nada o cuando el area no esta
     * cargada: dejar el lugar de entrega como estaba es mejor que apuntarlo a
     * un id inexistente.
     *
     * @param {number} comedorId - id del comedor elegido
     * @returns {?number} id del area forzada, o null
     */
    getLugarDeEntregaForzadoPorComedor = (comedorId) => {
        if (!this.isComedorGalvanSelected(comedorId)) return null;

        const { lugaresEntregaSelect } = this.state;
        const postaInflamables = lugaresEntregaSelect.find(
            lugarEntrega => lugarEntrega.nombre.toLowerCase() === "posta inflamables"
        );

        return postaInflamables ? postaInflamables.id : null;
    }

    handleLugarEntregaChange = (data) => {
        this.onChangeField('lugarEntrega', data ? data.id : null);
        // El lugar libre solo vale para la opcion "Otros"; si se eligio un area
        // de la lista se descarta lo que hubiera escrito antes.
        this.setState({ lugar_entrega_otros: null });
    }

    handleComedorChange = (data) => {
        const comedorId = data ? data.id : null;

        let error = this.state.errors;
        error['detalle_pedido'] = undefined;
        this.setState({ comedor_id: comedorId, producto_id: null, errors: error });
        this.filtrarProductosPorComedorConStock(comedorId);

        const lugarForzado = this.getLugarDeEntregaForzadoPorComedor(comedorId);
        if (lugarForzado !== null) {
            this.setState({
                lugarEntrega: lugarForzado,
                lugar_entrega_otros: null, // Por si se eligio Galvan despues de haber escrito un lugar especifico
            });
        }
    }

    componentDidMount = () => {
        this.fetchDataPedidos();
    }

    componentDidUpdate(prevProps) {
        const tipoPedidoChanged = this.props.tipo_pedido !== prevProps.tipo_pedido;
        const urlChanged = this.props.match.params.pedidoViandaCodigoVerificacion !== prevProps.match.params.pedidoViandaCodigoVerificacion;

        // Se resetea todo el componente cuando se cambia el tipo_pedido (Al ser un componente generico se actualizan los props, sin crear un componente nuevo)
        if (tipoPedidoChanged || urlChanged) {
            this.resetForm().then(() => {
                this.fetchDataPedidos();
            });
        }
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    setErrors(errors) {
        this.setState({ errors: errors });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    goToPedidoInsumosURL = () => {
        this.props.history.push('/pedidosinsumos/');
    }

    /**
     * El comedor ("Planta" en este formulario) que corresponde a una planta.
     *
     * Los pedidos de vianda y las personas guardan una Planta, y los pedidos de
     * producto un Comedor. Cada Comedor pertenece a una Planta y la relacion es
     * 1 a 1, asi que la correspondencia sale de `planta_id`.
     *
     * Devuelve null si ninguna fila coincide, y no el id de la planta: usarlo
     * como id de comedor era lo que se hacia antes (asumiendo que comparten el
     * id, cierto en los datos de hoy pero por casualidad) y podia terminar
     * apuntando a un comedor ajeno. Con null el campo queda vacio y
     * onValidation() lo reclama, que es preferible a guardar el comedor
     * equivocado sin avisar.
     *
     * @param {number} plantaId - id de la planta
     * @returns {?number} id del comedor correspondiente, o null
     */
    getComedorIdDePlanta = (plantaId) => {
        const { comedoresSelect } = this.state;
        const comedor = comedoresSelect
            ? comedoresSelect.find(c => c.planta_id === plantaId)
            : null;

        return comedor ? comedor.id : null;
    }

    /**
     * Se setean los datos segun lo cargado en el pedido de vianda
     */
    capturarDatosFromPedidoVianda = (pedidoViandaCodigoVerificacion) => {
        getPedidoViandaFromCodigoVerificacion(pedidoViandaCodigoVerificacion).then((responseVianda) => {
            const pedidoVianda = responseVianda.data
            // El lugar de entrega se repone como lo guardo el pedido de vianda:
            // si tiene un area elegida viene su id en lugar_de_entrega_id y se
            // selecciona en la lista; si era un lugar escrito a mano el id viene
            // en null y lo que se repone es la opcion "Otros" mas el texto
            // (lugar_de_entrega trae siempre el valor ya resuelto).
            const esLugarLibre = pedidoVianda.lugar_de_entrega_id == null;
            const lugarEntrega = esLugarLibre
                ? this.OPCION_LUGAR_ENTREGA_OTROS_ID
                : pedidoVianda.lugar_de_entrega_id;
            const lugarEntregaOtros = esLugarLibre ? pedidoVianda.lugar_de_entrega : null;
            const comedorId = this.getComedorIdDePlanta(pedidoVianda.planta.id);

            getDatosUsuarioLogueado().then((responseUsuario) => {
                const usuarioLogueado = responseUsuario.data;

                this.setState({
                    lugarEntrega: lugarEntrega,
                    lugar_entrega_otros: lugarEntregaOtros,
                    dependencia_id: usuarioLogueado.dependencia ? usuarioLogueado.dependencia.id : null,
                    comedor_id: comedorId,

                    persona_id: usuarioLogueado.id,
                    user_nombre: usuarioLogueado.nombre ? usuarioLogueado.nombre : null,
                    user_apellido: usuarioLogueado.apellido ? usuarioLogueado.apellido : null,
                }, () => {
                    this.filtrarProductosPorComedorConStock(comedorId)
                })
            })
        })
        .catch((error) => {
            // Para eliminar el codigo de verificacion de la url
            this.goToPedidoInsumosURL();
        })
    }

    /**
     * Setea los datos del usuario logueado que se recuperaron de la api.
     *
     * Es el camino del pedido individual (el de la adjuncion a una vianda es
     * capturarDatosFromPedidoVianda). La cabecera se propone con los datos de la
     * persona y queda editable: son valores por defecto, no impuestos.
     */
    capturarDatosUsuarioLogueado = () => {
        getDatosUsuarioLogueado().then((response) => {
                let data = response.data;

                // La "Planta" de un pedido de producto es un Comedor, y cada
                // Comedor pertenece a una Planta: como la relacion es 1 a 1, la
                // planta de la persona determina su comedor y se puede proponer
                // solo. Antes el usuario tenia que elegirlo a mano siempre.
                const comedorId = data.planta
                    ? this.getComedorIdDePlanta(data.planta.id)
                    : null;

                // Si ese comedor impone un lugar de entrega (Galvan solo puede
                // ser "Posta Inflamables") gana sobre el area de la persona: el
                // select va a quedar deshabilitado, asi que tiene que mostrar el
                // valor que efectivamente se va a guardar.
                const lugarForzado = this.getLugarDeEntregaForzadoPorComedor(comedorId);
                const areaDeLaPersona = data.area ? data.area.id : null;

                this.setState({
                    persona_id: data.id,
                    dependencia_id: data.dependencia ? data.dependencia.id : null,
                    comedor_id: comedorId,
                    // El area de la persona como lugar de entrega por defecto,
                    // igual que en el formulario de viandas
                    // (cargarDatosDelUsuario en FormViandas.js).
                    lugarEntrega: lugarForzado !== null ? lugarForzado : areaDeLaPersona,
                    user_nombre: data.nombre ? data.nombre : null,
                    user_apellido: data.apellido ? data.apellido : null,
                }, () => {
                    // Los productos que se pueden pedir dependen del comedor
                    // (cada uno tiene su propio stock), asi que la lista se
                    // filtra con el que se acaba de proponer.
                    this.filtrarProductosPorComedorConStock(comedorId);
                })
        })
    }

    /**
     * El lugar de entrega como lo espera la api: o el id de un area, o un texto
     * libre, nunca los dos (ver validate() en MisPedidosSerializer).
     */
    getLugarDeEntregaData = () => {
        const { lugarEntrega, lugar_entrega_otros } = this.state;
        const esLugarLibre = lugarEntrega === this.OPCION_LUGAR_ENTREGA_OTROS_ID;

        return {
            area_id: esLugarLibre ? null : lugarEntrega,
            otros_lugar_de_entrega: esLugarLibre ? lugar_entrega_otros : null,
        };
    }

    /**
     * Indica si falta elegir el lugar de entrega: o no se eligio nada, o se
     * eligio "Otros" y no se escribio donde.
     */
    faltaLugarDeEntrega = () => {
        const { lugarEntrega, lugar_entrega_otros } = this.state;

        if (lugarEntrega === null) return true;
        if (lugarEntrega !== this.OPCION_LUGAR_ENTREGA_OTROS_ID) return false;

        // lugar_entrega_otros vale null mientras no se escriba nada, asi que no
        // se puede llamar .trim() derecho.
        return !lugar_entrega_otros || lugar_entrega_otros.trim() === "";
    }

    // Valido los datos principales
    onValidation = () => {
        const { dependencia_id, persona_id, detalle_pedido, comedor_id } = this.state;
        let errors = {};
        let valid = true;

        if (this.faltaLugarDeEntrega()) {
            errors['lugarEntrega'] = [{ code: "blank", detail: "Seleccione un lugar de entrega" }]
            valid = false;
        }

        if (dependencia_id == null) {
            errors['dependencia_id'] = [{ code: "blank", detail: "Seleccione un Centro de Costo" }]
            valid = false;
        }

        if (persona_id == null) {
            errors['persona_id'] = [{ code: "blank", detail: "Seleccione una persona" }]
            valid = false;
        }

        if (detalle_pedido.length <= 0) {
            errors['detalle_pedido'] = [{ code: "blank", detail: "Debes agregar al menos un producto" }]
            valid = false;
        }

        if (comedor_id == null) {
            errors['comedor_id'] = [{ code: "blank", detail: "Seleccione un comedor" }]
            valid = false;
        }

        this.setState({ errors: errors })

        return valid
    }

    /**
     * Indica si la fecha tiene el formato DateTimeField exigido por la api
     * @param {string} datetime
     * @returns {boolean} true si es una fecha válida
     */
    isValidDateTime = (datetime) => {
        try {
            const parsed = new Date(datetime);
            return datetime === parsed.toISOString().slice(0, datetime.length);
        } catch (error) {
            return false;
        }
    }

    msjModalAdjuncion = (codigo_verificacion) => {
        const tipoPedido = getReadableTipoPedido(this.props.tipo_pedido).toLowerCase();

        return (
            <div>
                <p>El pedido fué adjuntado correctamente 🎉</p>
                <p>El código de verificación es el mismo para el pedido de vianda y el de {tipoPedido}</p>
                <p>Tu código de verificación es:</p>
                <p><strong>{codigo_verificacion}</strong></p>
            </div>
        )
    }

    msjModalIdividual = (codigo_verificacion) => {
        return (
            <div>
                <p>El pedido fué generado correctamente 🎉</p>
                <p>Tu código de verificación es:</p>
                <p><strong>{codigo_verificacion}</strong></p>
            </div>
        )
    }

    onSubmit = () => {
        const {
            dependencia_id,
            comedor_id,
            detalle_pedido,
            observacion,
            selected_fecha_entrega,
        } = this.state;

        const { tipo_pedido } = this.props
        const adjuntaPedido = this.props.match.params.pedidoViandaCodigoVerificacion;

        if (this.onValidation()) {
            // No se manda ni persona_id ni tipo_pedido: el responsable lo resuelve
            // el backend con el usuario del request, y la categoria con la ruta.
            // Tampoco el total: lo calcula el backend con el precio de cada producto
            // por la cantidad pedida.
            //
            // producto_id y cantidad tampoco van sueltos: son lo que esta elegido en
            // el formulario de "agregar", no parte del pedido. Lo que se pide va en
            // detalle_pedido.
            let data = {
                dependencia_id,
                comedor_id,
                observacion,
                ...this.getLugarDeEntregaData(),
                fecha_entrega: this.isValidDateTime(selected_fecha_entrega) ? selected_fecha_entrega : null,
                codigo_verificacion: this.props.match.params.pedidoViandaCodigoVerificacion || "",
            };

            // Solo que producto es y cuanto se pide. El id local es el del producto
            // (lo usa onAddinTable para detectar duplicados), no el de PedidosDetalle,
            // asi que no tiene sentido mandarlo: estos endpoints solo crean pedidos.
            data['detalle_pedido'] = detalle_pedido.map(d => ({
                producto_id: d.producto_id,
                cantidad: d.cantidad,
            }));
            // guardo el pedido y abro el modal de exito
            apiFunctions.post(getUrlMisPedidosTipoPedido(tipo_pedido), null, data,
                (response) => {
                    let codigo_verificacion = response.data.codigo_verificacion;

                    this.setState({
                        isOpenModal: true,
                        msjModal: adjuntaPedido ? this.msjModalAdjuncion(codigo_verificacion) : this.msjModalIdividual(codigo_verificacion),
                    })
                },
                // Un rechazo del backend tiene que verse en el formulario, igual
                // que en FormViandas: sin esto no aparece ni el modal de exito
                // ni ningun error.
                (response) => {
                    if (response.errors) {
                        this.setErrors(response.errors);
                    }
                }
            );

            if (adjuntaPedido){
                // Si el usuario terminó de adjuntar un pedido de insumo a un pedido de vianda hay que enviarlo a la url base
                // El componentDidUpdate() va a resetear los datos
                this.goToPedidoInsumosURL()
            } else {
                // Si el usuario está en la misma url se resetean los datos (está cargando pedidos de productos individuales, sin adjuntarlos)
                this.resetForm().then(() => {
                    this.fetchDataPedidos();
                })
            }
        }
    }

    // Abre o cierra el modal de mensajes al cargar el pedido
    changeIsOpenModal = () => {
        const { isOpenModal } = this.state;
        this.setState({ isOpenModal: !isOpenModal })
    }

    // Abre o cierra el modal de la lista de productos con stock
    changeIsOpenModalStock = () => {
        const { isOpenModalStock } = this.state;
        this.setState({ isOpenModalStock: !isOpenModalStock })
    }

    changeIsOpenPopoverAP = () => {
        this.setState({
            isOpenPopoverAP: false,
            producto: null,
            producto_id: null,
            cantidad: 0,
        })
    }

    /**
     * Setea los datos de los productos (vienen con el stock de cada comedor) traidos de la api
     * Cada tipo de pedido tiene su propio endpoint, que ya devuelve solo los productos de esa categoria
     * Usa promesa porque otra funcion lo requiere para usar el valor debido a su naturaleza async
     */
    traerProductos = () => {
        const parameters = {
            paginationEnabled: false
        };

        return new Promise((resolve, reject) => {
            apiFunctions.get(getUrlProductosTipoPedido(this.props.tipo_pedido), null, null, parameters, (response) => {
                this.setState({
                    productos: response.data
                }, () => {
                    resolve(response.data);
                });
            }, (error) => {
                reject(error);
            });
        });
    };

    /**
     * Formato de los datos de productos para tenerlos de forma acotada y filtrados por el id del comedor
     * Se guarda esta nueva lista de productosComedor en el state
     *
     * @param {Array} productos - Lista de productos traida de la api
     * @param {number} comedor_id - Id del comedor
     */
    formatProductosDelComedor = (productos, comedor_id) => {
        const productosComedor = productos.map((producto) => {
            const stockComedor = producto.stock_comedor_r.find((sc) => sc.comedor && sc.comedor.id === comedor_id);
            return {
                precio: producto.precio,
                nombre: producto.descripcion,
                id: producto.id,
                stock: stockComedor ? stockComedor.stock : 0,
            };
        }).filter((producto) => producto.stock > 0);

        this.setState({ productosComedor });
    }

    // Filtra los productos que tienen stock dependiendo del comedor
    filtrarProductosPorComedorConStock = (comedor_id) => {
        const { productos } = this.state;
        // si se selecciono un comedor se filtra por el mismo
        if (comedor_id != null) {
            // si hay productos en el array se filtran los mismos segun el stock en el comedor seleccionado
            if (productos.length > 0) {
                this.formatProductosDelComedor(productos, comedor_id);
            } else {
                // si el array productos esta vacio se traen y se filtran
                this.traerProductos().then((responseData) => this.formatProductosDelComedor(responseData, comedor_id))
            }
        } else {
            // si no se selecciono un comedor se guarda como array vacio
            this.setState({
                productosComedor: [],
            })
        }
    }

    // Valida el agregar un producto a la tabla
    addProducto = () => {
        const { producto, cantidad } = this.state;
        // si la cantidad seleccionada es mayor al stock se abre un popup para elegir la cantidad en stock o cancelar
        if (cantidad > producto.stock) {
            this.setState({
                isOpenPopoverAP: true,
                cantidad: producto.stock,
            })
        } else {
            // si la cantidad es menor o igual al stock se agrega a la tabla
            this.onAddinTable()
        }
    }

    // Agrega el producto seleccionado con su cantidad a la tabla
    onAddinTable = () => {
        const { producto_id, producto, cantidad, detalle_pedido } = this.state;

        let arrayPedido = [...detalle_pedido];
        // Valido que el producto no haya sido agregado (si ya fue agregado devuelve mensaje de error)
        const productoAgregadoAnteriormente = arrayPedido.find(producto => producto.id == producto_id)

        if (productoAgregadoAnteriormente) {
            this.setState({
                errors: { 'producto_id': [{ code: "blank", detail: "El producto ya fue agregado" }] },
                isOpenPopoverAP: false,
            })
        } else if (Number(cantidad) && Number(cantidad) > 0 && producto_id != null && producto != null) {
            // Ni unitario ni subtotal: esta pantalla no muestra importes en ningun
            // lado (ni la tabla de abajo ni ModalConfirmacionPedidoProducto), y los
            // montos del pedido los calcula el backend a partir del producto. Se
            // guardaban solo para mandarlos, y el backend los descarta.
            arrayPedido.push({
                id: producto.id,
                producto_id: producto_id,
                cantidad: parseInt(cantidad),
                nombre: producto.nombre,
            })
            // Limpio los errores y reseteo los input de producto y cantidad
            let error = this.state.errors;
            error['detalle_pedido'] = undefined;
            error['producto_id'] = undefined;
            this.setState({
                detalle_pedido: arrayPedido,
                cantidad: 0,
                producto_id: null,
                producto: null,
                errors: error,
                isOpenPopoverAP: false
            })
        }
    }

    // Elimino el producto seleccionado en la tabla
    onDeleteinTable = (id) => {
        const { detalle_pedido } = this.state;
        let arrayPedido = [...detalle_pedido];
        arrayPedido = arrayPedido.filter(d => d.producto_id != id);
        this.setState({ detalle_pedido: arrayPedido });
    }

    handleCantidadChange = (e) => {
        let cantidad = parseFloat(e.target.value);

        if (isNaN(cantidad)) cantidad = 0;
        cantidad = Math.max(cantidad, 0);

        if (this.props.tipo_pedido === abbreviatedTipoPedido.cafeteria) {
            // Redondear de a cuartos (1/4)
            cantidad = Math.round(cantidad * 4) / 4;
        } else {
            cantidad = Math.round(cantidad);
        }

        this.setState({ cantidad: cantidad });
    };

    render() {
        const {
            loading,
            dependencia_id,
            comedoresSelect,
            lugaresEntregaSelect,
            lugarEntrega,
            lugar_entrega_otros,
            producto_id,
            comedor_id,
            producto,
            cantidad,
            detalle_pedido,
            productosComedor,
            observacion,
            isOpenModal,
            msjModal,
            isOpenModalStock,
            isOpenPopoverAP,
            user_nombre,
            user_apellido,
        } = this.state;

        const {
            tipo_pedido
        } = this.props

        const iconoClassnameTipoPedido = getIconoClassnameTipoPedido(tipo_pedido);
        const iconoColorPedido = getIconoColorTipoPedido(tipo_pedido);

        // Cuando se adjunta a un pedido de vianda la cabecera la define ese
        // pedido: viene autocompletada y no se puede tocar.
        const adjuntandoAVianda = this.estaAdjuntandoAVianda();
        const esLugarLibre = lugarEntrega === this.OPCION_LUGAR_ENTREGA_OTROS_ID;

        const missingItemsPrincipal = [
            lugarEntrega === null && 'Lugar de entrega',
            esLugarLibre && (!lugar_entrega_otros || lugar_entrega_otros.trim() === "") && 'Especificar Lugar de entrega',
            dependencia_id === null && 'Centro de Costo ',
            comedor_id === null && 'Planta',
        ].filter(Boolean)

        const missingItemsDetallePedido = [
            detalle_pedido.length === 0 && 'Cargar al menos un producto',
        ].filter(Boolean);

        return (
            <div className={'mt-2'} style={{ maxHeight: "90vh" }}>
                {
                    Boolean(loading) &&
                    <div className="full-page-loader">
                        <BounceLoader />
                        <div className="mt-2" style={{ fontSize: '1.5rem' }}>{loading || 'Cargando...'}</div>
                    </div>
                }
                <Container className="p-2 px-md-5 position-relative contFormViandas" >
                    <Row className={''}>
                        <Col xs={12} lg={8} className="d-flex align-items-center flex-wrap">
                            <h1 className="d-inline-block display-4 mb-0" style={{ fontSize: '3rem' }}>
                                <i className={`me-2 mr-2 ${iconoClassnameTipoPedido}`} style={{ color: iconoColorPedido }}></i>
                                {'Nuevo Pedido de ' + getReadableTipoPedido(tipo_pedido)}
                            </h1>
                        </Col>
                    </Row>

                    <Row className={"mt-4"}>
                        <Col xs="6">
                            <ParadigmaLabeledInput
                                disabled={true}
                                className="mr-2"
                                md={[3, 9]}
                                maxLength={100}
                                label={"Responsable"}
                                value={user_nombre + ' ' + user_apellido}
                            />
                        </Col>

                        {/* Btn Ayuda Area Especifica */}
                        <Col className="col-1 d-flex align-items-center">
                            <Button
                                id="userResponsable"
                                size="sm"
                                color="warning"
                                className="rounded"
                            >    <i className="fa fa-question" />

                            </Button>
                        </Col>

                        {/* Tooltip Ayuda */}
                        <UncontrolledTooltip
                            className="rounded-tooltip"
                            placement="right"
                            target="userResponsable"
                        >
                            El Responsable del pedido siempre es el usuario actual
                        </UncontrolledTooltip>
                    </Row>

                    <Row className={"mt-2"}>
                        <Col xs="6">
                            <ParadigmaLabeledInput
                                md={[3, 9]}
                                label={"Planta"} // EX comedor, se mantienen los otros nombres de variables
                                error={() => this.getError('comedor_id')}
                                inputComponent={
                                    <ParadigmaAsyncSeeker
                                        // si ya se cargó un producto no se puede modificar el comedor
                                        // ya que cada comedor tiene sus propios productos y stocks
                                        //
                                        // Al adjuntar se bloquea solo si se pudo
                                        // resolver: si quedo vacio hay que poder
                                        // elegirlo, o el pedido no se puede cargar.
                                        disabled={(adjuntandoAVianda && comedor_id !== null) || detalle_pedido.length > 0}
                                        optionDefault={comedoresSelect}
                                        value={comedor_id}
                                        displayField={'nombre'}
                                        onChange={this.handleComedorChange}
                                    />
                                }
                            />
                        </Col>
                        <Col xs="6">
                            <ParadigmaLabeledInput
                                md={[4, 8]}
                                label={"Lugar de entrega"}
                                // lugarEntrega lo pone onValidation() y area_id
                                // el backend: el campo es el mismo.
                                error={() => this.getError('lugarEntrega') || this.getError('area_id')}
                                inputComponent={
                                    <ParadigmaAsyncSeeker
                                        optionDefault={lugaresEntregaSelect}
                                        value={lugarEntrega}
                                        disabled={this.isLugarDeEntregaInputDisabled()}
                                        onChange={this.handleLugarEntregaChange}
                                    />
                                }
                            />
                        </Col>
                    </Row>

                    {esLugarLibre && (
                        <Row className={"mt-2"}>
                            <Col xs="6"/>
                            {/* Input Lugar de entrega Especifica */}
                            <Col xs="6">
                                <ParadigmaLabeledInput
                                    md={[4, 8]}
                                    label={"Especificar"}
                                    maxLength={100}
                                    disabled={adjuntandoAVianda}
                                    value={lugar_entrega_otros}
                                    onChange={(e) => this.onChangeField("lugar_entrega_otros", e.target.value)}
                                />
                            </Col>
                        </Row>
                    )}
                    { tipo_pedido === abbreviatedTipoPedido.cafeteria &&
                        <Row className={"mt-2"}>
                            <Col xs="6"/>
                            <Col className={'col-6'}>
                                <ParadigmaLabeledInput 
                                    md={[4, 8]}
                                    label={"Fecha de entrega"} 
                                    inputComponent={
                                        <ParadigmaDatePicker
                                            className={'fecha-entrega-datetime-picker'}
                                            datetime={true}
                                            fechaDefault={true}
                                            onChange={fecha => this.setState({selected_fecha_entrega: fecha})}
                                        />
                                    } 
                                    error={() => this.getError('fecha_entrega')}
                                />
                            </Col>
                        </Row>
                    }

                    <Row className={'mt-2'}>
                        <Col xs="6">
                            <ParadigmaLabeledInput
                                md={[3, 9]}
                                label={"Centro de Costo"}
                                error={() => this.getError('dependencia_id')}
                                inputComponent={
                                    <ParadigmaAsyncSeeker
                                        disabled={adjuntandoAVianda}
                                        url={api.dependencias.dependenciasselect}
                                        parameters={{ paginationEnabled: false }}
                                        value={dependencia_id}
                                        displayField={'codigo'}
                                        onChange={data => {
                                            let error = this.state.errors;
                                            error['detalle_pedido'] = undefined;
                                            this.setState({ dependencia_id: (data) ? (data.id) : (null), errors: error })
                                        }}
                                    />
                                }
                            />
                        </Col>
                    </Row>

                    { /* ---------- Mensaje Falta Opcion ---------- */}
                    {missingItemsPrincipal.length > 0 ? (
                        <h5 className="faltanOpciones">
                            {'⬆ Faltan completar los campos correspondientes:'}
                            <ul className="list-unstyled text-center mb-0">
                                {missingItemsPrincipal.map(campoFaltante =>
                                    <li key={campoFaltante}>- {campoFaltante}</li>
                                )}
                            </ul>
                        </h5>
                    ) : null}

                    {missingItemsPrincipal.length == 0 &&
                        <React.Fragment>
                            <Row className={'mt-2'}>
                                <Fragment>
                                    <Col xs={12} className="col-separator my-2 py-1 ml-md-1">Detalle del Pedido</Col>
                                    <Col xs="7">
                                        <ParadigmaLabeledInput
                                            md={[3, 9]}
                                            label={"Producto"}
                                            error={() => this.getError('producto_id')}
                                            inputComponent={
                                                <ParadigmaAsyncSeeker
                                                    disabled={false}
                                                    clearable={true}
                                                    optionDefault={productosComedor}
                                                    value={producto_id}
                                                    displayField={'nombre'}
                                                    onChange={data => {
                                                        let error = this.state.errors;
                                                        error['producto_id'] = undefined;
                                                        error['detalle_pedido'] = undefined;
                                                        this.setState({
                                                            producto_id: (data) ? (data.id) : (null),
                                                            producto: (data) ? (data) : (null),
                                                            errors: error
                                                        })
                                                    }}
                                                />
                                            }
                                        />
                                    </Col>

                                    <Col xs="5">
                                        <ParadigmaLabeledInput
                                            md={[4, 8]}
                                            label={<div>Cantidad {(producto != null) && <i className="fa fa-circle ml-1" style={{ color: (producto.stock > 0) ? 'green' : 'red' }} />}</div>}
                                            error={() => this.getError('cantidad')}
                                            inputComponent={
                                                <Row>
                                                    <Col className={'9'}>
                                                        <Input
                                                            type="number"
                                                            value={cantidad}
                                                            disabled={false}
                                                            onChange={this.handleCantidadChange}
                                                            onFocus={(event) => event.target.select()}
                                                            step={this.props.tipo_pedido === abbreviatedTipoPedido.cafeteria ? "0.25" : "1"}
                                                        />
                                                    </Col>
                                                    <Col className={'3 py-0'}>
                                                        <Button
                                                            disabled={!(producto_id && cantidad > 0)}
                                                            color="success"
                                                            className="py-1 ml-2 rounded"
                                                            style={{
                                                                cursor: !(producto_id && cantidad > 0) ? 'not-allowed' : 'pointer',
                                                            }}
                                                            onClick={() => this.addProducto()}
                                                            id={'UTaddprod'}
                                                        >
                                                            <i className="fa fa-plus"></i>
                                                        </Button>

                                                        {producto_id && cantidad > 0 ? (
                                                            <UncontrolledTooltip
                                                                className="rounded-tooltip"
                                                                placement="bottom"
                                                                target="UTaddprod"
                                                            >
                                                                Agregar Producto
                                                            </UncontrolledTooltip>
                                                        ) : (
                                                            <UncontrolledTooltip
                                                                className="rounded-tooltip"
                                                                placement="bottom"
                                                                target="UTaddprod"
                                                            >
                                                                Seleccione un producto y una cantidad mayor a cero
                                                            </UncontrolledTooltip>
                                                        )}

                                                        {/* Popup a mostrar si la cantidad excede el stock */}
                                                        <Popover
                                                            placement={'bottom'}
                                                            isOpen={isOpenPopoverAP}
                                                            target={"UTaddprod"}
                                                            toggle={() => this.changeIsOpenPopoverAP()}
                                                        >
                                                            <PopoverHeader></PopoverHeader>
                                                            <PopoverBody>
                                                                <Row>
                                                                    <Label className={'text-center'} style={{ width: '100%' }}>
                                                                        {(producto) ?
                                                                            (<p>{'Hay '}<span style={{ fontWeight: 700 }}>{producto.stock}</span>{' ' + producto.nombre + ' en stock '}</p>)
                                                                            :
                                                                            'No hay stock suficiente'}
                                                                    </Label>
                                                                </Row>
                                                                <Row className={'px-3 mt-2'}>
                                                                    {/* permite agregar el producto con el maximo en stock */}
                                                                    <Button
                                                                        disabled={(!(producto_id && cantidad))}
                                                                        color="success"
                                                                        className="py-1 ml-2"
                                                                        onClick={() => this.onAddinTable()}
                                                                        id={'UTaddprod'}
                                                                    >{'Agregar ' + ((producto) ? (producto.stock) : ('Maximo'))}</Button>

                                                                    <Button
                                                                        disabled={(!(producto_id && cantidad))}
                                                                        color="success"
                                                                        className="py-1 ml-2"
                                                                        onClick={() => this.changeIsOpenPopoverAP()}
                                                                        id={'UTaddprod'}
                                                                    >Cancelar</Button>
                                                                </Row>
                                                            </PopoverBody>
                                                        </Popover>

                                                        {/* Abre el modal con la lista de productos */}
                                                        <Button
                                                            color="success"
                                                            className="py-1 ml-2 rounded"
                                                            onClick={() => this.changeIsOpenModalStock()}
                                                            id={'UTlistprod'}
                                                            style={{ float: 'right' }}
                                                        >
                                                            <i className="fa fa-file-text-o"></i>
                                                        </Button>
                                                        <UncontrolledTooltip
                                                            className="rounded-tooltip"
                                                            placement="right"
                                                            target="UTlistprod">
                                                            Listado de Productos
                                                        </UncontrolledTooltip>
                                                    </Col>
                                                </Row>
                                            }
                                        />
                                    </Col>
                                </Fragment>

                                {/* tabla de los productos seleccionados con su respectiva cantidad */}
                                <Col xs="12" className={'mt-2'}>
                                    <Table className="t_clientes">
                                        <thead>
                                            <tr>
                                                <th>Cantidad</th>
                                                <th>Nombre</th>
                                                <th>Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                detalle_pedido.map((d, i) =>
                                                    <tr key={i}>
                                                        <td width={"20px"}>{d.cantidad}</td>
                                                        <td>{d.nombre}</td>
                                                        <td width={"20px"}>
                                                            <Button className="icon btn btn-sm h-100 btn-danger rounded"
                                                                disabled={false}
                                                                onClick={() => this.onDeleteinTable(d.producto_id)}>
                                                                <i className="fa fa-minus m-auto"></i>
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </Table>

                                    {/* Errores */}
                                    {this.getError('detalle_pedido') &&
                                        <Alert color={'danger'}>{(this.getError('detalle_pedido')) ? (this.getError('detalle_pedido')[0].detail) : ('')}</Alert>}
                                </Col>
                            </Row>

                            { /* ---------- FOOTER ---------- */}
                            <Row>
                                <Col xs={12}>
                                    <ButtonToolbar className="my-3">
                                        <Button tag={Link} to="/tickets" outline className="mr-auto rounded">
                                            <i className="fa fa-long-arrow-left mr-2"></i>
                                            Volver
                                        </Button>

                                        <ModalConfirmacionPedidoProducto
                                            onSubmit={() => { this.onSubmit() }}
                                            title={'Confirmación del Pedido de ' + getReadableTipoPedido(tipo_pedido)}
                                            detalle={detalle_pedido}
                                            observacion={observacion}
                                            disabled={missingItemsDetallePedido.length > 0}
                                            missingItems={missingItemsDetallePedido}
                                            onChangeObservacion={(d) => this.setState({ observacion: d.target.value })}
                                        />
                                    </ButtonToolbar>
                                </Col>
                            </Row>
                        </React.Fragment>
                    }

                    {/* Modal mensaje submit */}
                    <Modal isOpen={isOpenModal} toggle={() => this.changeIsOpenModal()} className={"modal-primary"}>
                        <ModalHeader>
                            {'Pedido de ' + getReadableTipoPedido(tipo_pedido)}
                        </ModalHeader>
                        <ModalBody>

                            <h4 className={'text-center'}>{msjModal}</h4>

                        </ModalBody>
                        <ModalFooter>
                            <Button className="rounded" color="secondary" onClick={() => this.changeIsOpenModal()}>Volver</Button>
                        </ModalFooter>
                    </Modal>

                    {/* List productos con stock */}
                    <ModalListaDeProductos
                        isOpenModal={isOpenModalStock}
                        productosComedor={productosComedor}
                        toggleModalOpen={this.changeIsOpenModalStock}
                    />


                </Container>
            </div>
        );
    }
}

export default withRouter(FormPedidosProducto);



// WEBPACK FOOTER //
// ./src/views/PedidosProducto/FormPedidosProducto.js